import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

import * as Styles from '../Icon.module.scss';

export const DownloadIcon = ({ size = 'medium' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles['dsgGreen'], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            className={fillStyle}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm.213-9.21a1 1 0 0 1-1.32-.083l-6.6-6.6-.083-.095a1 1 0 0 1 .083-1.32l.094-.083a1 1 0 0 1 1.32.083l4.793 4.794V10l.007-.117A1 1 0 0 1 20.5 10v17.686l4.994-4.994.094-.083a1 1 0 0 1 1.32 1.498l-6.6 6.6z"
                fillRule="evenodd"
            />
        </svg>
    );
};
